import React, {Component} from "react";
import {Route} from "~services/RoutesService";
// Aliased import
import GenericMap from "~screens/Dashboard/screens/Projects/components/Map";
import {Project} from "~screens/Dashboard/screens/Projects/types";
import {BaseMap} from "~components/BaseMapSelector/baseMap";

export class Map extends Component<{ elements: (Route|Project)[], route?: Route, hoveredId?: number, baseMap?: BaseMap, zoom?: number, selectable?: boolean }, {}> {
    render() {
        const {elements, hoveredId, zoom, route, selectable, baseMap} = this.props;
        return (
            <GenericMap projects={elements} showContent={true} hoveredProjectId={hoveredId} zoom={zoom} route={route}
                        selectable={selectable} baseMap={baseMap}/>
        );
    }
}
